const wait = (ms = 250) => new Promise((resolve) => setTimeout(resolve, ms));

const mockState = {
  sessions: new Map(),
};

const random4Digits = () => String(1000 + Math.floor(Math.random() * 9000));
const randomSessionId = () => `sess_mock_${Date.now()}`;
const randomVirtualAccount = () => {
  const a = 100 + Math.floor(Math.random() * 900);
  const b = 10000 + Math.floor(Math.random() * 90000);
  const c = 10 + Math.floor(Math.random() * 90);
  return `${a}-${b}-${c}`;
};

const toBankName = (bankCode) => {
  const bankMap = {
    '004': 'KB국민은행',
    '088': '신한은행',
    '020': '우리은행',
    '081': '하나은행',
    '011': 'NH농협은행',
    '090': '카카오뱅크',
    '089': '케이뱅크',
    '092': '토스뱅크',
    '003': 'IBK기업은행',
    '007': '수협은행',
    '027': '한국씨티은행',
    '023': 'SC제일은행',
    '002': 'KDB산업은행',
    '045': '새마을금고',
    '048': '신협',
    '071': '우체국',
  };
  return bankMap[String(bankCode)] || '가상은행';
};

export const publicIssueMockApi = {
  startSession: async () => {
    await wait();
    const sessionId = randomSessionId();
    mockState.sessions.set(sessionId, {
      passCompleted: false,
      accountVerified: false,
      issued: false,
      devCode: random4Digits(),
    });
    return { session_id: sessionId };
  },

  getSession: async (sessionId) => {
    await wait();
    const session = mockState.sessions.get(sessionId);
    if (!session) {
      return null;
    }
    return {
      session_id: sessionId,
      pass_completed: session.passCompleted,
      account_verified: session.accountVerified,
      issued: session.issued,
    };
  },

  startPass: async () => {
    await wait();
    // redirect 대신 인앱 fallback 루트를 타도록 mock 모드 반환
    return { mode: 'mock' };
  },

  completePass: async ({ sessionId, name, phone }) => {
    await wait();
    const session = mockState.sessions.get(sessionId);
    if (!session) {
      throw new Error('mock session not found');
    }
    session.passCompleted = true;
    return {
      session_id: sessionId,
      name: name || '홍길동',
      phone: phone || '01012341234',
      verified: true,
    };
  },

  requestAccountVerification: async ({ sessionId }) => {
    await wait();
    const session = mockState.sessions.get(sessionId);
    if (!session) {
      throw new Error('mock session not found');
    }
    return {
      session_id: sessionId,
      requested: true,
      dev_verification_code: session.devCode,
    };
  },

  confirmAccountVerification: async ({ sessionId, verificationCode }) => {
    await wait();
    const session = mockState.sessions.get(sessionId);
    if (!session) {
      throw new Error('mock session not found');
    }
    if (String(verificationCode) !== String(session.devCode)) {
      throw new Error('mock verification code mismatch');
    }
    session.accountVerified = true;
    return { session_id: sessionId, verified: true };
  },

  issueVirtualAccount: async ({ sessionId, bankCode }) => {
    await wait();
    const session = mockState.sessions.get(sessionId);
    if (!session) {
      throw new Error('mock session not found');
    }
    if (!session.passCompleted || !session.accountVerified) {
      throw new Error('mock flow not completed');
    }
    session.issued = true;
    return {
      session_id: sessionId,
      bankName: toBankName(bankCode),
      virtualAccountNumber: randomVirtualAccount(),
    };
  },
};
